export const groupByAlphabet = <T extends { lembaga: string }>(
  items: T[],
): Record<string, Record<string, T[]>> => {
  const groups: Record<string, Record<string, T[]>> = {};

  items.forEach((item) => {
    const country = item.lembaga;
    const firstLetter = country.charAt(0).toUpperCase();

    if (!groups[firstLetter]) {
      groups[firstLetter] = {};
    }
    if (!groups[firstLetter][country]) {
      groups[firstLetter][country] = [];
    }
    groups[firstLetter][country].push(item);
  });

  // Sort countries within each letter group
  Object.keys(groups).forEach((letter) => {
    const sortedCountries: Record<string, T[]> = {};
    Object.keys(groups[letter])
      .sort()
      .forEach((country) => {
        sortedCountries[country] = groups[letter][country];
      });
    groups[letter] = sortedCountries;
  });

  return groups;
};

export const getAvailableLetters = (
  groupedData: Record<string, Record<string, any[]>>,
): string[] => {
  return Object.keys(groupedData).sort();
};

export const getAllLetters = (): string[] => {
  return "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
};

export const getTotalCountries = (
  groupedData: Record<string, Record<string, any[]>>,
): number => {
  return Object.values(groupedData).reduce(
    (total, letterGroup) => total + Object.keys(letterGroup).length,
    0,
  );
};

export const getTotalDocuments = (
  groupedData: Record<string, Record<string, any[]>>,
): number => {
  return Object.values(groupedData).reduce(
    (total, letterGroup) =>
      total +
      Object.values(letterGroup).reduce(
        (letterTotal, countryItems) => letterTotal + countryItems.length,
        0,
      ),
    0,
  );
};
